import { ButtonSizeVariants } from "@insite/mobius/Button";
import getColor from "@insite/mobius/utilities/getColor";
import { buttonBaseStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export const buttonType = {
    solid: "solid",
    outline: "outline",
};

export type ButtonVariants = "primary" | "secondary" | "tertiary" | "quarternary" | "quinary";
export type ButtonShapes = "rectangle" | "pill" | "rounded";
export type ButtonActiveHoverMode = "darken" | "lighten";
export type ButtonType = "solid" | "outline";

export const buttonBaseProps = {
    hoverMode: "lighten" as ButtonActiveHoverMode,
    activeMode: "darken" as ButtonActiveHoverMode,
    sizeVariant: "medium" as ButtonSizeVariants,
    typographyProps: {
        weight: TYPOGRAPHY.weight.black,
        size: TYPOGRAPHY.size.smaller,
    },
    shape: "rounded" as ButtonShapes,
};

export default {
    primary: {
        ...buttonBaseProps,
        color: "primary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
    secondary: {
        ...buttonBaseProps,
        color: "secondary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
    tertiary: {
        ...buttonBaseProps,
        color: "primary",
        buttonType: buttonType.outline,
        css: css`
            ${buttonBaseStyles(buttonType.outline)}
        `,
    },
    quarternary: {
        ...buttonBaseProps,
        color: "quarternary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
            &:not(:disabled):hover {
                background: ${getColor("quarternary.light")};
                border-color: ${getColor("quarternary.light")};
            }
        `,
    },
    quinary: {
        ...buttonBaseProps,
        color: "quinary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
            &:not(:disabled):hover {
                background: ${getColor("quinary.light")};
                border-color: ${getColor("quinary.light")};
            }
        `,
    },
    defaultProps: {
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
};
